import { PRODUCTS } from '../config/constants';

export default function getNomeProduto(codigo) {
  const key = String(codigo).padStart(5, '0');
  const produto = PRODUCTS[key];
  return (produto && produto.name) || 'Produto não encontrado';
}
